//import packages from node modules
import React, { useState,useEffect,useRef,useCallback } from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {reduxForm,Field} from 'redux-form'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

//import shared components

import Heading from '../../typography/heading'
import Description from '../../typography/description'
import Tabs from '../../tabs'
import SearchDomain from '../../searchdomain'
import SelectDomainConfig from '../selectdomainconfig'
import PageSlider from '../../pageslider'

//import shared utility functions
import {
  ADD_PRODUCT_PAGE,
  EDIT_PRODUCT_PAGE
} from '../../../../utilities/function/common'

import {
  getCartToken
} from '../../../../utilities/function/cartToken'

import {
  getCID,
  getDataFromURL,
  getPageByURL
} from '../../../../utilities/function/urlparams'

import {
  getServiceTypeFromProductConfig,
  getUpdateProductConfigPayload,
  isLastStep,
  getFilteredConfigurationList
} from '../../../../utilities/function/configuration'

import {
  addItemToCart,
  CART_LOADING, editProductPage,
  loadConfiguration,
  updateCartItem,
  updateConfig
} from '../../../../app/action'
import { DOMAIN_TYPE, GSUITE_TYPE, SHARED_HOSTING_TYPE } from '../../../../utilities/function/servicetype'
import { cancelCheckDomain, cancelGetDomainSuggestions } from '../../../../utilities/api/domain'
import { getConfigurationListHaveDomainName } from '../../../../utilities/function/manageServiceTypes'


//import shared components
import Dropdown from '../../form/dropdown'
import TextField from '../../form/textfield'
import SolidButton from '../../button/solidbutton'
import CART_API from '../../../../utilities/api/cart'
import Ellipsis from "../../ellipsis";


let DomainNameInCart = (props) =>{
  const {handleSubmit} = props
  const configurations = useSelector(state=>state.app.configurations)
  const hasHosting = useCallback((domainname) => {
    const hostinglist = getFilteredConfigurationList(SHARED_HOSTING_TYPE,configurations,true)
    const gsuitelist = getFilteredConfigurationList(GSUITE_TYPE,configurations,true)
    let productwithdomainname = []
    if(hostinglist && hostinglist.length){
      productwithdomainname = productwithdomainname.concat(hostinglist)
    }
    if(gsuitelist && gsuitelist.length){
      productwithdomainname = productwithdomainname.concat(gsuitelist)
    }
    if(productwithdomainname && productwithdomainname.length){
      return productwithdomainname.find(item=>item.name===domainname)
    }
    return false
  },[configurations])
  const getDomainNamesInCart = useCallback(()=>{
    const domainlist = getFilteredConfigurationList(DOMAIN_TYPE,configurations,true)
    const availableDomainNameList = []
    if(domainlist && domainlist.length){
      domainlist.forEach(domain=>{
        const {name} = domain
        const notAvailable =  hasHosting(name)
        if(!notAvailable){
          availableDomainNameList.push(domain)
        }
      })
    }
    return availableDomainNameList
  },[configurations,hasHosting])
  const domainNameInCart = getDomainNamesInCart()
  const renderField = () => {
    if(domainNameInCart && domainNameInCart.length===1){
      return (<>
        <Field name={'selected_cart_domainname'} readOnly={true} type={'hidden'}component={TextField} initialValue={domainNameInCart[0].name}/>
        <div className={'of-domain-in-cart__locked lines-border-1-100'}>{domainNameInCart[0].name}</div>
      </>)
    }
    if(domainNameInCart && domainNameInCart.length>1){
      const getList = () => {
        return domainNameInCart.map(item=>({
          label: item.name,
          value: item.name
        }))
      }
      return (<Field name={'selected_cart_domainname'} className={'of-domain-in-cart__dropdown'} component={Dropdown} list={getList()} initialValue={domainNameInCart[0].name}/>)
    }
    return (<></>)
  }
  const renderButton = () => {
    //const cid = getCID(getDataFromURL(location.search))
    let text = 'Use Domain'
   /* if(configurations && cid && configurations[cid] && isLastStep(configurations[cid].breadcrumbs , configurations[cid].step)){
      text = 'Add to Cart'
    }*/
    return ( <SolidButton className={'of-domain-in-cart__button'} type={'submit'}>{text}</SolidButton>)
  }
  if(domainNameInCart && domainNameInCart.length){
    return(
      <div className={'of-domain-in-cart lines-border-1-100'}>
        <div className={'of-domain-in-cart__wrapper'}>
          <div className={'of-domain-in-cart__heading text-font-3-100'}>USE DOMAIN ALREADY IN CART</div>
          <form onSubmit={handleSubmit} className={'of-domain-in-cart__form'}>
            {renderField()}
            {renderButton()}
          </form>
        </div>
      </div>
    )
  }
  return (<></>)
}

DomainNameInCart.propTypes = {
  handleSubmit : PropTypes.any,
  location: PropTypes.object
}

DomainNameInCart = withRouter(DomainNameInCart)
DomainNameInCart = reduxForm({
  form: 'DomainInCart',
})(DomainNameInCart)

let ChangeDomainName = (props) => {
  const {productConfig,location,history} = props
  const dispatch = useDispatch()
  const {configurations,cartData} = useSelector(state=>({
    configurations: state.app.configurations,
    cartData: state.app.cartData
  }))
  const cid = getCID(getDataFromURL(location.search))
  const pageType =getPageByURL(location.search)
  const continueButtonOnClick = (e) => {
    e.preventDefault()
    if(isLastStep(productConfig.breadcrumbs,productConfig.step)){
      if(pageType===EDIT_PRODUCT_PAGE){
        editProductPage(cid,configurations,cartData,dispatch,location,history)
      }else{
        addItemToCart(productConfig,dispatch,history,configurations,location)
      }
    }else{
      const step = configurations[cid] && configurations[cid].step?configurations[cid].step+1:2
      updateConfig(configurations,cid,{
        step
      },dispatch)
    }
  }
  const buttonOnClick = (e) =>{
    e.preventDefault()
    if(productConfig && productConfig.name){
      const newconfig = Object.assign({},productConfig)
      delete newconfig['name']
      const newconfigurations = Object.assign({},configurations)
      newconfigurations[cid] = newconfig
      if(newconfigurations[productConfig.name]){
        delete newconfigurations[productConfig.name]
        loadConfiguration(newconfigurations,dispatch)
      }else{
        const getDomainNameInCart = () => {
          let selected = null
          if(cartData && cartData.items && cartData.items.length > 0){
            cartData.items.forEach(item=>{
              const {name,uuid} = item
              if(name === productConfig.name ){
                const domainConfig = newconfigurations[uuid]
                if(domainConfig && getServiceTypeFromProductConfig(domainConfig) === DOMAIN_TYPE){
                  selected =item
                }
              }
            })
          }
          return selected
        }
        if (getDomainNameInCart()) {
          const domain = getDomainNameInCart()
          if (domain && domain.uuid) {
            delete newconfigurations[domain.uuid]
            loadConfiguration(newconfigurations,dispatch)
            CART_API.deleteItem( getCartToken(), domain.uuid)
          }
        }else{
          loadConfiguration(newconfigurations,dispatch)
        }
      }
    }
  }
  if(productConfig && productConfig.name){
    const getName = () => {
      const string = productConfig.name.split(".")
      if(string && string.length>0){
        return string[0]
      }
      return null
    }
    const getTLD = () =>{
      let string = productConfig.name.split(".")
      if(string && Array.isArray(string) && string.length>=1){
        string.shift()
        if(Array.isArray(string) && string.length>1){
          string = string.join(".")
        }
        return "."+string
      }
      return null
    }
    let text = 'Continue'
    const renderBottom = () => {
      const renderContinue = (text)=>{
        return(
          <div className={'of-change-domainname__bottom'}>
            <SolidButton className={'of-change-domainname__continue-button'} onClick={continueButtonOnClick}>{text}</SolidButton>
          </div>
        )
      }
      if(isLastStep(productConfig.breadcrumbs,productConfig.step)){
        if(pageType===EDIT_PRODUCT_PAGE){
          text='Update'
        }else{
          text='Proceed to Cart'
        }
      }
      return (renderContinue(text))
    }
    const renderEllipsis = () => {
      const isActive = getName() && getName().length >32
      const getFormat = () => {
        const first = getName().substring(0,10)
        const last = getName().substring(getName().length -10)
        return(<div className={'of-change-domainname__name text-font-3-100'}>{first}...{last}<strong className={'text-font-1-100'}>{getTLD()}</strong></div>)
      }
      if(getName()){
        return (
            <Ellipsis isActive={isActive} format={getFormat()} tooltip={`${getName()}${getTLD()}`}>
              <div className={'of-change-domainname__name text-font-3-100'}>{getName()}<strong className={'text-font-1-100'}>{getTLD()}</strong></div>
            </Ellipsis>
        )
      }
      return <></>
    }
    return(
      <div className={'of-change-domainname'}>
        <div className={'of-change-domainname__top lines-border-1-100'}>
          {renderEllipsis()}
          <SolidButton onClick={buttonOnClick} isSecondary={true} className={'of-change-domainname__button text-font-1-100'}>Change</SolidButton>
        </div>
        {renderBottom()}
      </div>
    )
  }
  return (<></>)
}

ChangeDomainName = withRouter(ChangeDomainName)

ChangeDomainName.propTypes = {
  productConfig: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object
}





let SelectHostingDomain = (props) => {
  const { cid ,location,history} = props
  const [isNewDomainName, setIsNewDomainName] = useState(true)
  const [domainPage,setDomainPage] = useState(0)
  const [domainList,setDomainList] = useState(null)
  const {configurations,cartData,cartStatus} = useSelector(state=>({
    configurations: state.app.configurations,
    cartData: state.app.cartData,
    cartStatus: state.app.cartStatus
  }))
  const pageType = getPageByURL(location.search)
  const currentStep = (configurations[cid] && configurations[cid].step)
  const currentStepFlag= useRef(currentStep)
  const dispatch = useDispatch()
  const setDomainNameCallback = useCallback((value, isTransferMode, isNewDomainName) => {
    if (!isNewDomainName && !isTransferMode) {
      if(configurations[cid] &&
        configurations[cid].step >=0
        && configurations[cid].breadcrumbs){
        if(isLastStep(configurations[cid].breadcrumbs,configurations[cid].step)){
          dispatch({
            type: CART_LOADING
          })
          updateConfig(configurations, cid, {
            name: value,
            isNewDomainName,
            isTransferMode
          }, dispatch)
          window.setTimeout(()=>{
            const pageType = getPageByURL(location.search)
            if(pageType===ADD_PRODUCT_PAGE){
              addItemToCart(configurations[cid],dispatch,history,configurations,location)
            }else if(pageType===EDIT_PRODUCT_PAGE){
                const payload = getUpdateProductConfigPayload(configurations[cid],cartData,cid)
                if(payload && Object.keys(payload).length > 0){
                  updateCartItem(payload,dispatch,history,`?a=checkout`,configurations[cid])
                }
            }
          },300)
        }else{
          updateConfig(configurations, cid, {
            name: value,
            step: configurations[cid].step+1,
            isNewDomainName,
            isTransferMode
          }, dispatch)
        }
      }
    }
  }, [dispatch, configurations, cid,history,cartData,location])
  const clearDomainOnLoadFlag = useRef(false)
  const timeout = useRef(null)
  const clearDomain = useCallback(() =>{
    const newConfigurations = {}
    Object.keys(configurations).forEach(key => {
      if (configurations[key]
        && configurations[key].uuid) {
        newConfigurations[key] = configurations[key]
      } else {
        if(configurations[key].order_type && configurations[key].domainSearchResult){
          const {domainSearchResult} = configurations[key]
          if(domainSearchResult){
            const {domain,tld} = domainSearchResult
            const name = domain+tld
            const list = getConfigurationListHaveDomainName(configurations)
            if(list && list.length && Array.isArray(list)){
              list.forEach(item=>{
                if(item.name===name){
                  newConfigurations[key] = configurations[key]
                }
              })
            }
            if(configurations[cid] && name && name === configurations[cid].name){
              newConfigurations[key] = configurations[key]
            }
          }
        }else{
          newConfigurations[key] = configurations[key]
        }
      }
    })
    loadConfiguration(newConfigurations,dispatch)
  },[configurations,dispatch,cid])
  const clearDomainOnLoad = useCallback(()=>{
    if(!clearDomainOnLoadFlag.current && cartStatus==="success"){
      if (timeout.current) {
        window.clearInterval(timeout.current)
      }
      timeout.current = window.setTimeout(()=>{
        if (configurations && Object.keys(configurations).length > 0) {
          clearDomain()
          clearDomainOnLoadFlag.current = true
        }
      },300)
    }
  },[configurations,clearDomainOnLoadFlag,cartStatus,clearDomain])
  const checkDomainNameConfig = useCallback(()=>{
    if(configurations && cid && configurations[cid]){
      const productConfig = configurations[cid]
      if(productConfig && productConfig.step !==undefined && productConfig.breadcrumbs){
        if(Object.keys(productConfig.breadcrumbs).length){
          Object.keys(productConfig.breadcrumbs).forEach(index=>{
            if(productConfig.breadcrumbs[index] && productConfig.breadcrumbs[index].configKey==="name"){
              if(productConfig.breadcrumbs[index].itemStep=== productConfig.step){
                //check if domain name has not been set then reset domain name config
                if(productConfig.name === undefined){
                  clearDomain()
                }
              }
            }
          })
        }
      }
    }
  },[configurations,cid,clearDomain])

  useEffect(()=>{
    clearDomainOnLoad()
    if(currentStep!== currentStepFlag.current){
      setDomainPage(0)
      checkDomainNameConfig()
      currentStepFlag.current = currentStep
    }
  },[currentStep,currentStepFlag,clearDomainOnLoad,  checkDomainNameConfig])
  const getTabList = () => {
    let tabList = []
    tabList.push({
      label: 'I need a domain name',
      onClick: () => {
        setIsNewDomainName(true)
      }
    })
    tabList.push({
      label: 'I already have a domain name',
      onClick: () => {
        setIsNewDomainName(false)
      }
    })
    return tabList
  }
  const searchDomainInit = (setIsTransferMode,searchFieldEl) =>{
    if(configurations && configurations[cid]){
      const productConfig = configurations[cid]
      const {name,isTransferMode} = productConfig
      if(name){
        searchFieldEl.current.value = name
      }
      setIsTransferMode(!!isTransferMode)
    }
  }
  const tabInit = (setIndex) =>{
    if(configurations && configurations[cid]){
      const flag = configurations[cid].isNewDomainName
      if(flag===false){
        setIndex(1)
        setIsNewDomainName(false)
      }else{
        setIndex(0)
        setIsNewDomainName(true)
      }
    }else{
      setIndex(0)
      setIsNewDomainName(true)
    }
  }
  const searchItemCallback = (step,domainconfig) => {
    if(cancelCheckDomain){
      cancelCheckDomain()
    }
    if(cancelGetDomainSuggestions){
      cancelGetDomainSuggestions()
    }
    setDomainPage(step)
    setDomainList([domainconfig])
  }
  const domainInCartOnSubmit = (values) => {
    const {selected_cart_domainname} = values
    if(selected_cart_domainname){
      const productConfig = configurations[cid]
      if(productConfig && productConfig.step>=0 && productConfig.breadcrumbs){
        if(isLastStep(productConfig.breadcrumbs,productConfig.step)){
          if(pageType===EDIT_PRODUCT_PAGE){
            updateConfig(configurations,cid,{
              name: selected_cart_domainname
            },dispatch)
            const payloadHosting = getUpdateProductConfigPayload(configurations[cid],cartData,cid)
            updateCartItem(payloadHosting,dispatch,history,'?a=checkout',configurations[cid])
          }else if(pageType===ADD_PRODUCT_PAGE){
            updateConfig(configurations,cid,{
              name: selected_cart_domainname
            },dispatch)
            addItemToCart(configurations[cid],dispatch,history,configurations,location)
          }
        }else{
          updateConfig(configurations,cid,{
            name: selected_cart_domainname,
            step: currentStep? currentStep+1 :1
          },dispatch)
        }
      }
    }
  }
  const renderMain = () => {
    const productConfig = configurations[cid]
    if(productConfig && productConfig.name){
      return (<ChangeDomainName productConfig={productConfig} />)
    }
    return (
      <>
        <div className={'of-select-hosting-domain__panel'}>
          <DomainNameInCart onSubmit={domainInCartOnSubmit}/>
          <Tabs className='of-select-hosting-domain__tabs' list={getTabList()} init={tabInit}/>
        </div>
        <SearchDomain searchItemCallback = {searchItemCallback} onSubmit={setDomainNameCallback} className='of-select-hosting-domain__searchdomain' isNewDomainName={isNewDomainName} init={searchDomainInit}/>
      </>
    )
  }

  const getProductTypeLabel = () => {
    if(configurations && configurations[cid]){
      const type = getServiceTypeFromProductConfig(configurations[cid])
      if(type==="shared_hosting"){
        return 'hosting'
      }else if(type==="gsuite"){
        return 'G Suite'
      }
      return type
    }
    return <></>
  }


  return (
    <PageSlider step={domainPage} className={'of-domain-page-slider'}>
      <div className='of-select-hosting-domain of-step of-domain-page-slider__step'>
        <div className='of-select-hosting-domain__container'>
          <Heading className='of-select-hosting-domain__heading'>What is your domain name?</Heading>
          <Description className='of-select-hosting-domain__description'>Select the domain name you wish to use with
            this {getProductTypeLabel()} service.</Description>
          {renderMain()}
        </div>
      </div>
      <SelectDomainConfig domainList={domainList} setDomainPage={setDomainPage}/>
    </PageSlider>
  )
}

SelectHostingDomain.propTypes = {
  cid: PropTypes.any,
  location: PropTypes.any,
  history: PropTypes.any
}

SelectHostingDomain = withRouter(SelectHostingDomain)

export default SelectHostingDomain
